var map = {
	"./center-blue.svg": "Yd4W",
	"./center.svg": "6J2j",
	"./left-blue.svg": "qAKv",
	"./left.svg": "Hu+Y",
	"./right-blue.svg": "Wlcp",
	"./right.svg": "ryXo"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LP5z";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/column-alignment ^\.\/.*\.svg$
// module id = LP5z
// module chunks = 46